import {
  HOME_GET_SYSTEM_COUNT_BEGIN,
  HOME_GET_SYSTEM_COUNT_SUCCESS,
  HOME_GET_SYSTEM_COUNT_FAILURE,
  HOME_GET_SYSTEM_COUNT_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getSystemCount(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_GET_SYSTEM_COUNT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:'/api/b/system/count',
          data:params,
        }).then( data => {
            dispatch({
                type: HOME_GET_SYSTEM_COUNT_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: HOME_GET_SYSTEM_COUNT_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetSystemCountError() {
  return {
    type: HOME_GET_SYSTEM_COUNT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_GET_SYSTEM_COUNT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getSystemCountPending: true,
        getSystemCountError: null,
      };

    case HOME_GET_SYSTEM_COUNT_SUCCESS:
      // The request is success
      
      return {
        ...state,
        getSystemCountPending: false,
        getSystemCountError: null,
        companyAll:action.data.companyAll,
        companyToday:action.data.companyToday,
        positionAll:action.data.positionAll,
        positionToday:action.data.positionToday,
        userAll:action.data.userAll,
        userToday:action.data.userToday,
      };

    case HOME_GET_SYSTEM_COUNT_FAILURE:
      // The request is failed
      return {
        ...state,
        getSystemCountPending: false,
        getSystemCountError: action.data.error,
      };

    case HOME_GET_SYSTEM_COUNT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getSystemCountError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/getSystemCount.js